const DEFAULT_SEPARATORS = [';', '|', ','];

// Override global del separador de multiresposta, triat per l'usuari a la pantalla de
// càrrega (sincronitzat des del fileStore). null/'' = Auto: es fa servir l'ordre de
// candidats / el separador configurat del camp. Un valor concret ('|', ';', ',') el FORÇA
// a TOTES les divisions de multivalor, guanyant per sobre del configurat al camp (que de
// vegades no casa amb les dades, p.ex. camp amb ';' però dades amb '|').
let forcedSeparator = null;

export function setMultiSeparator(sep) { forcedSeparator = sep || null; }
export function getMultiSeparator() { return forcedSeparator; }

export function splitMulti(value, separators = DEFAULT_SEPARATORS) {
  if (value === null || value === undefined || value === '') return [];
  if (Array.isArray(value)) return value.map((v) => (v == null ? '' : String(v).trim())).filter(Boolean);
  const str = String(value);
  const seps = forcedSeparator ? [forcedSeparator] : separators;
  for (const sep of seps) {
    if (str.includes(sep)) {
      return str.split(sep).map((s) => s.trim()).filter(Boolean);
    }
  }
  return [str.trim()].filter(Boolean);
}

export function validateMinMax(value, mandatory) {
  if (!mandatory) return { valid: true, count: 0 };
  const min = mandatory.min ?? 0;
  const max = mandatory.max ?? Infinity;
  const list = splitMulti(value, mandatory.separators);
  const count = list.length;

  if (mandatory.required && count === 0) {
    return { valid: false, code: 'MANDATORY', count, min, max };
  }
  if (count < min) return { valid: false, code: 'RANGE_MIN', count, min, max };
  if (count > max) return { valid: false, code: 'RANGE_MAX', count, min, max };
  return { valid: true, count, min, max };
}
